import { getGlobalTransformer } from "../../components/Editor/util/shapeCategorySingleton";

type OptionalLayerAndDash = {
  layer?: string,
  dash?: number[],
  dashID?: number;
  layerId?: number;
}
// Subtract, omit the props not needed in save file.
type ExportLineShape = Omit<LineShape, keyof OptionalLayerAndDash> & OptionalLayerAndDash
type ExportCircleShape = Omit<CircleShape, keyof OptionalLayerAndDash> & OptionalLayerAndDash
type ExportSymbolShape = Omit<SymbolShape, keyof OptionalLayerAndDash> & OptionalLayerAndDash
type ExportTextShape = Omit<TextShape, keyof OptionalLayerAndDash> & OptionalLayerAndDash
type ExportArcShape = Omit<ArcShape, keyof OptionalLayerAndDash> & OptionalLayerAndDash
type ExportGeometricShape =
  ExportLineShape
  | ExportSymbolShape
  | ExportCircleShape
  | ExportTextShape
  | ExportArcShape
  | RectShape

export function createSaveData(modelData: ModelData, lineTypes: LineType[], layerTypes: Layer[]) {
  const glob: ExportGeometricShape[] = modelData.shapes.map((s) => {
    const trans = getGlobalTransformer(s.type);
    if (trans) {
      return trans(s);
    }
    return undefined;
  }
  ).filter((c) => c !== undefined) as GeometricShape[]



  let temporaryShapelist: ExportGeometricShape[] = glob;
  temporaryShapelist = renameKey(temporaryShapelist, "layerId", "layer", findTheLayerFromId)
  temporaryShapelist = renameKey(temporaryShapelist, "dashID", "dash", findTheLineTypeFromId)

  function findTheLayerFromId(g: ExportGeometricShape) {
    const layi = layerTypes.findIndex(layer => layer.id === g.layerId);
    return layerTypes[layi]?.name
  }
  function findTheLineTypeFromId(g: ExportGeometricShape) {
    if ("dashID" in g) {
      const dashi = lineTypes.findIndex(line => line.id === g.dashID);
      return lineTypes[dashi]?.dash
    }
  }
  function renameKey<T extends keyof ExportGeometricShape>(
    group: ExportGeometricShape[],
    oldKey: string,
    newKey: string,
    modifierFunction: (a: ExportGeometricShape) => any) {
    return group.map(g => {
      if (oldKey in g) {
        const temp = modifierFunction(g)
        delete g[oldKey as T]
        return { ...g, [newKey]: temp }
      } else return g
    }
    )
  }

  const formattedData = formatShapesData(temporaryShapelist)
  return formattedData;
}

function formatShapesData(shapes: ExportGeometricShape[]): any[] {

  const exportArray: any[] = shapes.map((shape) => {
    const { snapPoint, height, width, ...shapeReduced } = shape as GeometricShape;
    return { ...shapeReduced }
  });
  return exportArray
}
